import { React, _n } from 'pexui';

const MissingDetailsHeader = ({ fgMismatchErrors }) => (
  <div id="missing-info-template">
    <div className="infw-font-bold">
      Additional Information Required.
    </div>
    {fgMismatchErrors.map(error => (
      <div className="infw-faq-title infw-font-bold mismatch-error">
        <span
          ariaLabel="warning icon"
          role="alert"
          className="infw-icon-warning dls-icon-warning-filled dls-accent-red-01 mismatch-error-icon"
        />
        {error}
      </div>
    ))}
    <div className='missing-details-footer'>
      {_n('yodlee.account_mismatch.subtitle')}
    </div>
  </div>
);

export default MissingDetailsHeader;



// WEBPACK FOOTER //
// ./application/src/views/yodlee/missingDetailsHeader.js